import { Edge, Node } from 'react-flow-renderer';

export const removeNodes = (data: any, id: string) => {
    data.setNodes((node: Node[]) => node.filter((el) => el.id !== id));
    data.setEdges((eds: Edge[]) => eds.filter((el) => el.target !== id));
};
